module.exports = __webpack_public_path__ + "media/images/img/banner/bnr_special_contents_002-4a233fe0600a5175fba3f04676969045.jpg";